import { send } from '../../../../../../src/network/network';
import { type PatchedCustomerOccasionEntity } from '../../../../../../src/types/PatchedCustomerOccasionEntity';

export async function patchApiV2CustomersOccasionEntityPreferences(
  payload: PatchedCustomerOccasionEntity[]
) {
  return await send<PatchedCustomerOccasionEntity[]>({
    path: '/api/v2/customers/self/occasion_entity_preferences/',
    method: 'PATCH',
    body: payload,
  });
}
